var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 21,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pin-filled_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "pin-filled_svg__b",
  width: 21,
  height: 21,
  x: -1,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-.002.23h20v20h-20z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#pin-filled_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#81109C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: "m.78 19.449 6.283-6.284"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#81109C",
  d: "m18.113 6.535-5.011 5.011a6.25 6.25 0 0 1-1.619 6.038L2.645 8.745a6.25 6.25 0 0 1 6.037-1.618l5.011-5.01"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#81109C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: "m18.113 6.535-5.011 5.011a6.25 6.25 0 0 1-1.619 6.038L2.645 8.745a6.25 6.25 0 0 1 6.037-1.618l5.011-5.01M12.588 1.011l6.629 6.63"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pin-filled_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .23h20v20H0z"
})))));
export default SvgPinFilled;